export default "__VITE_ASSET__d0642c6d__"